// extracted by mini-css-extract-plugin
export default {"global-layout":"Global_global-layout__DmbCh","global-layout__body":"Global_global-layout__body__BZ9oF","global-layout__body--body":"Global_global-layout__body--body__csxPZ"};